import React, { BaseSyntheticEvent } from 'react';
import { Select, SelectProps } from '@chakra-ui/react';

interface SelectCustomProps extends Omit<SelectProps, 'onChange'> {
  placeholder: string;
  options: { value: string; label: string }[];
  onChange?: (value: string) => void;
}

export const SelectCustom: React.FC<SelectCustomProps> = ({
  placeholder,
  options,
  onChange,
  ...rest
}) => {
  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e: BaseSyntheticEvent) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Select placeholder={placeholder} onChange={handleChange} {...rest}>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};
